import {
  localize,
  ValidationProvider,
  extend,
  ValidationObserver,
} from "vee-validate";
import Vue from "vue";
import * as rules from "vee-validate/dist/rules";
import { locales } from "@/plugins/vee-validate-i18n";

const initializeVeeValidate = () => {
  localize({ en: locales.en });
  Vue.component("ValidationObserver", ValidationObserver);
  Vue.component("ValidationProvider", ValidationProvider);

  Object.keys(rules).forEach((rule) => extend(rule, rules[rule]));
};
export default initializeVeeValidate;
